import React, { FC } from 'react';
import { TextDnd } from '../text-dnd';
import cls from './image-placeholder.module.scss';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from 'constants/breakpoints';
import { ReactComponent as StatusFailedIcon } from 'assets/images/elearning/topic-status/status_failed.svg';
import { ReactComponent as StatusSuccessIcon } from 'assets/images/elearning/topic-status/status_success.svg';

interface IProps {
    id: string;
    text: string;
    isEmpty?: boolean;
    imgSrc: string;
    isCorrect: boolean | undefined;
    feedback: string;
}

function itemToLetter(itemKey: string): string {
    const number = parseInt(itemKey.split('_')[1], 10);
    return String.fromCharCode(96 + number);
}

export const ImagePlaceholder: FC<IProps> = ({
    text,
    id,
    isEmpty,
    imgSrc,
    isCorrect,
    feedback
}) => {
    const isMD = !useMedia(BREAKPOINTS.MD);
    const maxLength = 10;
    const maxLengthDesktop = 40;

    const trimmed = (text: string) => {
        const limit = isMD ? maxLength : maxLengthDesktop;
        return text.length > limit ? text.slice(0, limit) + '...' : text;
    }

    return (
        <div
            className={`${cls.wrapper} ${
                isCorrect === true ? cls.correct : ''
            } ${isCorrect === false ? cls.inCorrect : ''}`}
            >
            {isEmpty ? (
                <div className={cls.emptyBox}>
                    <span className={cls.emptyBoxSpan}></span>
                </div>
            ) : (
                <TextDnd
                    id={id}
                    text={text}
                    source="start-area"
                    imgSrc={imgSrc}
                />
            )}

            <p className={cls.paragraf}>
                {isCorrect === true ? (
                    <StatusSuccessIcon className={cls.statusIcon} />
                ) : isCorrect === false ? (
                    <StatusFailedIcon className={cls.statusIcon} />
                ) : (
                    <span
                        className={`${cls.letter} ${
                            isEmpty ? cls.letterEmpty : ''
                        }`}
                    >
                        {itemToLetter(id)}
                    </span>
                )}
                <span className={cls.text}>{isCorrect === undefined ? trimmed(text) : feedback}</span>
            </p>
        </div>
    );
};
